import React from 'react';

import App from 'app/App';
import { runNativeBoot } from 'app/services/nativeBoot';
import {
  armNativeSplashFailsafe,
  hideNativeSplash,
  suppressWebSplashOnNative,
} from 'app/services/nativeSplash';
import { hydrateSecureTokenStore } from 'app/services/secureTokenStore';
import storage from 'app/services/storage';
import { createRoot } from 'react-dom/client';

import { LS_DOMAIN_NAME } from 'constants/localStorage';
// import { IS_PRODUCTION } from 'constants/envs';
import { logger } from 'utils/logger';
import { getIsNativePlatform } from 'utils/platform';

import './styles/index.css';

// On native, hide the WebView boot splash immediately so the HELD native splash
// (launchAutoHide:false) is the only boot screen — no second, mismatched flash. No-op on web.
suppressWebSplashOnNative();
// Arm the splash failsafe BEFORE the boot chain runs, so even a throw or a never-settling promise
// below can't leave the held native splash up forever (STP-177).
armNativeSplashFailsafe();

if (process.env.REACT_APP_TUNNEL_MODE === 'true' && !storage.getItem(LS_DOMAIN_NAME)) {
  const domain = process.env.REACT_APP_TUNNEL_DOMAIN || 'interfirst-admin.dev-lender.com';
  storage.setItem(LS_DOMAIN_NAME, domain);

  // The domain is seeded into storage synchronously above, before createRoot()/render() runs
  // below, so App already reads it on this same boot — the reload only exists to restart web
  // boot cleanly. On a bundled Capacitor app under capacitor://localhost a reload would just
  // re-run the whole boot chain (churning the native SIP registration) and, if lsDomainName
  // ever failed to persist, spin a boot loop. Native never reloads here (DEV-4332).
  if (!getIsNativePlatform()) {
    window.location.reload();
  }
}

hydrateSecureTokenStore()
  .then(runNativeBoot)
  .catch(error => logger.error('[Boot] native boot failed', error))
  .finally(() => {
    try {
      createRoot(document.getElementById('root')).render(<App />);
    } finally {
      // Hide the held native splash via setTimeout, NOT requestAnimationFrame: while the splash
      // occludes the WebView, iOS pauses the rAF display-link, so an rAF-scheduled hide never fires
      // and the splash sticks (notably on the Face-ID resume path, STP-177). A timer fires
      // regardless of occlusion; the try/finally keeps the hide reachable even if render throws.
      setTimeout(() => hideNativeSplash(), 0);
    }
  });

// TODO: temporarily disable SW, find out why condition does not work,
// if ('serviceWorker' in navigator && IS_PRODUCTION) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then(registration => {
//         logger.log('SW registered: ', registration);
//       })
//       .catch(registrationError => {
//         logger.error('SW registration failed: ', registrationError);
//       });
//   });
// }
